// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3UC1W","title":"ClientReferral_title__24n68","itemText":"ClientReferral_itemText__dd1Yd"};